import Controller from "./rescueReasons.controller";
import template from "./rescueReasons.html";

const rescueReasons = {
  template,
  controller: Controller,
  bindings: {
    city: "<",
    model: "=",
  },
};

export default rescueReasons;



// WEBPACK FOOTER //
// ./src/components/rescueReasons/rescueReasons.component.js